import { TYPE_COLLECTION } from './input-types';

export const id = 'shippingBillToParty';
export const apiKey = 'BillToParty';
export const type = TYPE_COLLECTION;

export const shippingBillToParty = {
  id,
  apiKey,
  type,
};
